import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const HeroSectionsDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Hero Sections"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
